import { CreateEventFormValues } from '../ui/dialogs/createEventFormSchema';
import { CalendarEventUpdateFormValues } from '../ui/card/calendarEventUpdateFormSchema';
import { CreateCallActivityVariables, UpdateCallActivityVariables } from '../../api/types';
import { DealActivityLinkType, DealActivityType, DealEventActivityViewModel } from '@trnsact/trnsact-shared-types';

interface EventDatesFormValues {
  allDay: boolean;
  endAt: string | null;
  endDate: string | null;
  startAt: string | null;
  startDate: string | null;
}

interface EventDatesPayload {
  allDay: boolean;
  endAt?: string;
  endDate?: string;
  startAt?: string;
  startDate?: string;
}

export class CalendarFormMapper {
  static mapFormDtoToCreate = (values: CreateEventFormValues): CreateCallActivityVariables['input'] => {
    const { accountId, assignedTo, allDay, startAt, startDate, endAt, endDate, ...rest } = values;

    return {
      parentId: accountId,
      type: DealActivityType.Event,
      parentType: DealActivityLinkType.Account,
      ...rest,
      ...CalendarFormMapper.buildEventDatesPayload({ allDay, startAt, startDate, endAt, endDate }),
    };
  };

  static mapFormDtoToUpdate = (
    event: DealEventActivityViewModel,
    values: CalendarEventUpdateFormValues
  ): UpdateCallActivityVariables['input'] => {
    const { allDay, startAt, startDate, endAt, endDate, ...rest } = values;

    return {
      id: event.id,
      parentId: event.parentId,
      type: DealActivityType.Event,
      parentType: DealActivityLinkType.Account,
      ...rest,
      ...CalendarFormMapper.buildEventDatesPayload({ allDay, startAt, startDate, endAt, endDate }),
    };
  };

  private static buildEventDatesPayload = ({
    allDay,
    endAt,
    endDate,
    startAt,
    startDate,
  }: EventDatesFormValues): EventDatesPayload => {
    const payload: EventDatesPayload = { allDay };

    if (allDay) {
      if (startDate) payload.startDate = startDate;
      if (endDate) payload.endDate = endDate;
    } else {
      if (startAt) payload.startAt = startAt;
      if (endAt) payload.endAt = endAt;
    }

    return payload;
  };
}
